class MozActivityManager {
  constructor() {
    this.iac_kaipay = 'kaipay-to-kaistore';
    this.taskQueue = [];
  }

  handleActivity(activityRequest) {
    var option = activityRequest.source;
    switch (option.name) {
      case 'open-page':
      case 'open-by-name':
      case 'inline-open-page':
      case 'inline-open-by-name':
        this.saveToQueue(option);
        break;
      default:
        break;
    }
  }

  // XXX: In the future, we will use these order info to recover the intermittent orders.
  // If the order has been completed, we will remove it after download success.
  handleIAC(iacRequest) {
    // Inter APP Communication with KaiPay
    if (iacRequest.keyword === this.iac_kaipay) {
      let port = iacRequest.port;
      port.onmessage = function onReceivedMessage(evt) {
        let eventData = evt.data;
        let productId = eventData.productID;
        let orderData = eventData.data;
        let orderId = orderData.orderId;

        if (productId && orderId) {
          // add update time to data
          eventData.updateTime = evt.timeStamp;
          // insert or update the order info into indexDB (use "kaipay-{productId}" to be the key)
          asyncStorage.setItem(`${this.iac_kaipay}-${productId}`, eventData);
        }
      }.bind(this);
    }
  }

  saveToQueue(option) {
    if (!option) {
      return;
    }
    this.taskQueue.push(option);
    window.dispatchEvent(new CustomEvent('task-queue-updated'));
  }

  get task() {
    if (this.taskQueue.length === 0) {
      return false;
    } else {
      return this.taskQueue.pop();
    }
  }
}

export let mozActivityManager = new MozActivityManager();



/** WEBPACK FOOTER **
 ** ./src/mozactivity-manager.js
 **/